"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../../../../material/index");

var _index2 = require("../../../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _daypicker_styles = _interopRequireDefault(require("./daypicker_styles"));

var _daypicker_definition = _interopRequireDefault(require("./daypicker_definition"));

var _definecomponent = require("../../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ========== ~~~~~~~~~~ EXPORT : DROPDOWN : DAY PICKER ~~~~~~~~~~ ========== */


var DayPickerDropDown =
/*#__PURE__*/
function (_Component) {
  _inherits(DayPickerDropDown, _Component);

  function DayPickerDropDown(props) {
    var _this;

    _classCallCheck(this, DayPickerDropDown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DayPickerDropDown).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleOutsideClick", function (e) {
      // ignore clicks on the component itself
      if (!_this.node.contains(e.target) && _this.state.active) {
        _this.hideMenu();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDayClick", function (day) {
      _this.props.selectDay("".concat((0, _index2.zeroPadding)(day.getFullYear(), 2), "-").concat((0, _index2.zeroPadding)(day.getMonth() + 1, 2), "-").concat((0, _index2.zeroPadding)(day.getDate(), 2)));

      _this.hideMenu();
    });

    _defineProperty(_assertThisInitialized(_this), "showMenu", function () {
      return _this.setState({
        active: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hideMenu", function () {
      return _this.setState({
        active: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      return _this.state.active ? _this.hideMenu() : _this.showMenu();
    });

    _defineProperty(_assertThisInitialized(_this), "renderDay", function (selectedDay) {
      //let { selectedDay } = this.state;
      return selectedDay ? "".concat((0, _index2.zeroPadding)(selectedDay.getMonth() + 1, 2), "/").concat((0, _index2.zeroPadding)(selectedDay.getDate(), 2), "/").concat((0, _index2.getLastTwoDigit)(selectedDay.getFullYear())) : "Select a day";
    });

    _this.state = {
      active: false
    };
    return _this;
  }

  _createClass(DayPickerDropDown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      return document.addEventListener('mousedown', this.handleOutsideClick, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      return document.removeEventListener('mousedown', this.handleOutsideClick, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var active = this.state.active;
      return _react.default.createElement("div", {
        className: "datepickerdropdown daypickerdropdown dropdown ".concat(this.props.classes.daypickerdropdown),
        ref: function ref(node) {
          _this2.node = node;
        }
      }, _react.default.createElement("div", {
        className: "placeholder active-".concat(active),
        onClick: this.handleClick
      }, _react.default.createElement("span", null, this.renderDay(new Date(this.props.selectedDay.split('-').join('/')))), _react.default.createElement(_index.Icon, {
        name: "sort-down"
      })), _react.default.createElement(_index.Group, {
        name: "dropdown active-".concat(active)
      }, _react.default.createElement(_index.DatePicker, {
        selectedDay: this.props.selectedDay,
        handleRangeSelect: this.handleDayClick,
        disabledDays: this.props.disabledDates,
        type: 'day',
        numberOfMonths: 1
      })));
    }
  }]);

  return DayPickerDropDown;
}(_react.Component);
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */


(0, _definecomponent.defineComponent)(DayPickerDropDown, _daypicker_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = (0, _reactJss.default)(_daypicker_styles.default)(DayPickerDropDown);

exports.default = _default;